import { Component } from '@theme/component';

/**
 * A custom element that manages a card that can open/close additional content.
 *
 * @typedef {object} Refs
 * @property {HTMLDetailsElement[]} details - The toggle that opens/closes the content.
 *
 * @extends {Component<Refs>}
 */
class DisclosureCards extends Component {
  constructor() {
    super();
    this.handleSwiper();
  }
  /**
   * Handles closing
   *
   * @param {PointerEvent} event - The pointer event.
   */
  dismiss(event) {
    const details = this.querySelectorAll('[ref="details"]');
    const target = event.target;

    details.forEach((detail) => {
      if (detail.getAttribute('open')) {
        detail.classList.add('closing');
        detail.addEventListener('animationend', () => {
          if (target != detail.querySelector('button')) {
            detail.style.zIndex = '0';
          }
          detail.removeAttribute('open');
          detail.classList.remove('closing');
        });
      }
    });
  }

  /**
   * Handles opening and closing of nearest neighbour
   *
   * @param {PointerEvent} event - The pointer event.
   */
  handleOpen(event) {
    const details = this.querySelectorAll('[ref="details"]');

    const target = event.target;

    details.forEach((detail) => {
      const parent = detail.closest('li');
      if (target == detail.querySelector('button')) {
        if (parent) {
          parent.style.zIndex = '20';
        }
      }
      if (detail.getAttribute('open')) {
        detail.classList.add('closing');
        if (parent && target !== detail.querySelector('button')) {
          parent.style.zIndex = '';
        }
        detail.addEventListener('animationend', () => {
          detail.removeAttribute('open');
          detail.classList.remove('closing');
        });
      }
      if (target == detail.querySelector('button')) {
        detail.setAttribute('open', 'true');
      }
    });
  }

  /**
   * Handles Swiper interactivity
   *
   */
  handleSwiper() {
    const mediaWatcher = window.matchMedia('(max-width: 1280px)');
    const swipers = [];

    const handleMediaWatcherChange = (matchMedia) => {
      const details = this.querySelectorAll('[ref="details"]');
      const more_than_three = details.length - 1 > 3;
      if (matchMedia.matches || more_than_three) {
        const swiperContainers = document.querySelectorAll(
          '[id^="featuredGridSwiper-"]',
        );
        swiperContainers.forEach((container) => {
          const swiperElement = container.querySelector('.featuredGridSwiper');
          const swiper = new Swiper(swiperElement, {
            slidesPerView: matchMedia.matches && more_than_three ? 3 : 1,
            spaceBetween: matchMedia.matches && more_than_three ? 24 : 0,
            navigation: {
              nextEl:
                '[id^="featuredGridSwiper-"] .swiper-buttons .swiper-button-next',
              prevEl:
                '[id^="featuredGridSwiper-"] .swiper-buttons .swiper-button-prev',
            },
            pagination: {
              el: container.querySelector('.swiper-pagination'),
              clickable: true,
              type: 'progressbar',
            },
          });
          swiper.init();
          swipers.push(swiper);
        });
      } else {
        swipers.forEach((swiper) => swiper?.destroy());
      }
    };

    mediaWatcher.addEventListener('change', handleMediaWatcherChange);
    handleMediaWatcherChange(mediaWatcher);
  }
}

if (!customElements.get('disclosure-cards')) {
  customElements.define('disclosure-cards', DisclosureCards);
}
